import { render, staticRenderFns } from "./ModalSousCategorie.vue?vue&type=template&id=4a59b1a6&scoped=true"
import script from "./ModalSousCategorie.vue?vue&type=script&lang=js"
export * from "./ModalSousCategorie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a59b1a6",
  null
  
)

export default component.exports